import base from "../baseurl";
import token from "../getTk";

const showAll = async (endpoint) => {
  const tokenA = token.get();

  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const Show = await api.get(`${endpoint}`).json();

  return Show;
};

export default showAll;
